import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import i18next from 'i18next';
import { toLightweightDeviation } from '@wix/da-editor-tiptap/pkg/extensions/utils/toLightweightDeviation';
export function createWithDeviation(_param) {
    var { extended } = _param, deviation = _object_without_properties(_param, [
        "extended"
    ]);
    return {
        excerpt: '',
        html: {
            type: 'tiptap',
            markup: JSON.stringify({
                version: '1',
                document: {
                    type: 'doc',
                    content: [
                        {
                            type: 'paragraph',
                            attrs: {
                                indentType: null,
                                indentation: '',
                                textAlign: 'left'
                            },
                            content: [
                                {
                                    type: 'text',
                                    text: i18next.t('editor.shareToPost.text')
                                }
                            ]
                        },
                        {
                            type: 'da-deviation',
                            attrs: {
                                deviation: toLightweightDeviation(deviation),
                                alignment: 'center',
                                link: null,
                                width: null
                            }
                        }
                    ]
                }
            }),
            features: '[]'
        }
    };
}
export function createWithDeviationAndText(_param, text = i18next.t('editor.shareToPost.text')) {
    var { extended } = _param, deviation = _object_without_properties(_param, [
        "extended"
    ]);
    return {
        excerpt: '',
        html: {
            type: 'tiptap',
            markup: JSON.stringify({
                version: '1',
                document: {
                    type: 'doc',
                    content: [
                        {
                            type: 'paragraph',
                            attrs: {
                                indentType: null,
                                indentation: '',
                                textAlign: 'left'
                            },
                            content: [
                                {
                                    type: 'text',
                                    text
                                }
                            ]
                        },
                        {
                            type: 'da-deviation',
                            attrs: {
                                deviation: toLightweightDeviation(deviation),
                                alignment: 'center',
                                link: null,
                                width: null
                            }
                        }
                    ]
                }
            }),
            features: '[]'
        }
    };
}

//# sourceMappingURL=creators.js.map